import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { seasonsService } from '../services/seasons.service'
import type { FilmDocument } from '@/types'

interface UseFilmResult {
  film: (FilmDocument & { id: string }) | null
  loading: boolean
  error: string | null
}

export function useFilm(slug: string | undefined): UseFilmResult {
  const [film, setFilm] = useState<(FilmDocument & { id: string }) | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!slug) return
    seasonsService
      .getFilmBySlug(slug)
      .then(setFilm)
      .catch((err: unknown) => setError(formatUserFacingError(err, 'Failed to load film')))
      .finally(() => setLoading(false))
  }, [slug])

  return { film, loading, error }
}
